import request from '@/utils/request'

let CommonApi = {


    getSettings(data, errorback) {
        return request._get('/shop/Index/getSetting', data, errorback);
    },
   getInas(data, errorback) {
        return request._get('/shop/Index/getInas', data, errorback);
    },
}
export default CommonApi;



// WEBPACK FOOTER //
// ./src/api/common.js